import CompanyUserHSAStatus from '../../domain/companies/companyUserHSAStatus'
import { adminHttpClient } from '../commons/adminHttpClient'
import PagedFilter from '../commons/pagedFilter'
import PagedList from '../commons/pagedList'

export interface PagedEmployeeHSAStatus extends PagedList<EmployeeHSAStatus> {}

export interface EmployeeHSAStatus {
  companyUserId: string
  contributesToHSA: boolean
  year: number
  createdBy: string
  createdAt: string
  lastModifiedBy: string
  lastModifiedAt: Date
}

export interface EmployeeHSAStatusChanges {
  contributesToHSA: boolean
  year: number
}

export const getHSAStatus = (data: PagedFilter) => {
  return adminHttpClient.get('/EEDashboard/Profile/UserHSAStatusHistory', data)
}

export const updateHSAStatus = (data: EmployeeHSAStatusChanges): Promise<CompanyUserHSAStatus> => {
  return adminHttpClient.put('/EEDashboard/Profile/UserHSAStatusHistory', data)
}

export const getUserHSAStatusByYear = (year: string): Promise<CompanyUserHSAStatus> => {
  return adminHttpClient.get(`/EEDashboard/Profile/UserHSAStatusByYear/${year}`)
}
